/**
 * Shared utilities for the app backend API calls.
 * All requests use JWT from localStorage admin_token.
 */
import { APP_BACKEND } from "@/lib/backends";

// El hostname ya no se escribe aquí: se resuelve en `@/lib/backends`, que es el
// único sitio del frontend que sabe dónde vive cada backend. Ver
// `docs/DESLIGAR-DE-RENDER.md`.
export const APP_API = `${APP_BACKEND}/api`;

export function getToken() {
  return localStorage.getItem("admin_token") || "";
}

export function authHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getToken()}`,
  };
}

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${APP_API}${path}`, {
    ...options,
    headers: {
      ...authHeaders(),
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.detail || err?.message || `Error ${res.status}`);
  }
  // 204 No Content
  if (res.status === 204) return null;
  return res.json();
}

export async function apiGet(path) {
  return apiFetch(path);
}

export async function apiPost(path, body) {
  return apiFetch(path, { method: "POST", body: JSON.stringify(body) });
}

export async function apiPut(path, body) {
  return apiFetch(path, { method: "PUT", body: JSON.stringify(body) });
}

export async function apiPatch(path, body) {
  return apiFetch(path, { method: "PATCH", body: JSON.stringify(body) });
}

export async function apiDelete(path) {
  return apiFetch(path, { method: "DELETE" });
}
